<script setup lang="ts">
const siteConfig = useSiteConfig()

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [
    { href: '/favicon.ico', rel: 'icon', type: 'image/x-icon' },
    { href: '/icon.svg', rel: 'icon', sizes: 'any', type: 'image/svg+xml' },
    { href: '/icon.svg', rel: 'apple-touch-icon', type: 'image/svg+xml' },
  ],
  meta: [
    { content: 'width=device-width, initial-scale=1', name: 'viewport' },
    { content: siteConfig.version, name: 'version' },
    { content: siteConfig.env, name: 'environment' },
    // og:logo is non-standard but several validators (Schema.org, LinkedIn,
    // Slack unfurl previews) check for it. Point at the brand mark on the
    // canonical origin so it resolves regardless of which page is shared.
    { content: `${siteConfig.url}/icon.svg`, property: 'og:logo' },
  ],
  titleTemplate: titleChunk => {
    return titleChunk && titleChunk !== siteConfig.name ? `${titleChunk} - ${siteConfig.name}` : siteConfig.name
  },
})

useSeoMeta({
  description: siteConfig.description,
  ogDescription: siteConfig.description,
  ogSiteName: siteConfig.name,
  ogTitle: siteConfig.name,
  ogType: 'website',
  ogUrl: siteConfig.url,
  title: siteConfig.name,
  twitterCard: 'summary_large_image',
})

// Site-wide default OG image. Per-page calls to defineOgImageComponent
// override this so each route ships its own prerendered preview PNG.
defineOgImageComponent('Default')

useSchemaOrg([
  defineWebSite({
    description: siteConfig.description,
    name: siteConfig.name,
  }),
  defineWebPage(),
])
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </UApp>
</template>
